// TODO: Yield description should come from API or brand data
export const MOCK_YIELD_DESCRIPTION = 'Market-neutral BTC yield'
